import { defaultPfmlFormValues, PfmlFormValues } from "./PfmlFormValues";
import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { QuarterlyEarnings } from "../domain/QuarterlyEarnings";
import { DateTime } from "luxon";
import { PaymentPreference } from "../enums/PaymentPreference";
import { BankAccountType } from "../enums/BankAccountType";
import { WorkSchedule } from "../enums/WorkSchedule";
import { Taxation } from "../enums/Taxation";

export type PfmlEmployerFormValues = EmployerFormValues & PfmlFormValues & {
    phoneNumber: string,
    jobTitle: string,
    workSchedule: WorkSchedule,
    weeklyWorkSchedule: [{
        sunday: string,
        monday: string,
        tuesday: string,
        wednesday: string,
        thursday: string,
        friday: string,
        saturday: string,
    }],
    dateReturnedToWork: string,
    priorDisability: boolean,
    priorDisabilityDates: [{
        startDate: string,
        endDate: string
    }],
    priorPaidFamilyMedicalLeave: boolean,
    priorPaidFamilyMedicalLeaveDates: [{
        startDate: string,
        endDate: string
    }],
    priorPaidFamilyMedicalLeaveHours: string,
    workRelated: string,
    payAfterDateLastWorked: string,
    fullPayAfterDateLastWorked: string,
    payTypesAfterDateLastWorked: [{
        payType: string,
        startDate: string,
        endDate: string,
        totalHoursPaid: string,
        percentagePaid: string,
        estimateAmount: string,
        incorrectEstimate: boolean,
        amount: string
    }]
    earningsQuarters: QuarterlyEarnings[],
    earningsLastYear: string,
    employerReimbursement: string,
    employerReimbursementConsent: boolean,
    employerSignature: string,
    employerSignatureDate: string,
    employerPaymentPreference: PaymentPreference,
    employerAccountNumber: string,
    employerAccountNumber2: string,
    employerRoutingNumber: string,
    employerAccountType: BankAccountType,
    eftConsent: boolean,
    minimumRequiredHoursWorked: string,
    premiumsAddedToEmployeesWages: string,
    premiumTaxation: Taxation,
    rate: string,
    workLocation: string,
    paidFamilyLeavePremiumsAddedToEmployeesWages: string,
    paidFamilyLeavePremiumTaxation: Taxation,
    paidMedicalLeavePremiumsAddedToEmployeesWages: string,
    paidMedicalLeavePremiumTaxation: Taxation,
    paidMedicalLeaveRate: string,
    paidFamilyLeaveRate: string
}

export const defaultPfmlEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultPfmlFormValues,
    phoneNumber: '',
    jobTitle: '',
    workSchedule: '',
    weeklyWorkSchedule: [{
        sunday: '',
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
    }, {
        sunday: '',
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
    }],
    dateReturnedToWork: '',
    priorDisability: false,
    priorDisabilityDates: [{
        startDate: '',
        endDate: ''
    }],
    priorPaidFamilyMedicalLeave: false,
    priorPaidFamilyMedicalLeaveDates: [{
        startDate: '',
        endDate: ''
    }],
    priorPaidFamilyMedicalLeaveHours: '',
    workRelated: '',
    payAfterDateLastWorked: '',
    fullPayAfterDateLastWorked: '',
    payTypesAfterDateLastWorked: [{
        payType: '',
        startDate: '',
        endDate: '',
        totalHoursPaid: "",
        percentagePaid: "",
        estimateAmount: "",
        incorrectEstimate: "",
        amount: ""
    }],
    earningsLastYear: '',
    earningsQuarters: [{
        startDate: '',
        endDate: '',
        amount: ''
    }, {
        startDate: '',
        endDate: '',
        amount: ''
    }, {
        startDate: '',
        endDate: '',
        amount: ''
    }, {
        startDate: '',
        endDate: '',
        amount: ''
    }, {
        startDate: '',
        endDate: '',
        amount: ''
    }],
    employerReimbursement: '',
    employerReimbursementConsent: false,
    employerSignature: '',
    employerSignatureDate: DateTime.now().toFormat('MM/dd/yyyy'),
    employerPaymentPreference: PaymentPreference.EFT,
    employerAccountNumber: '',
    employerAccountNumber2: '',
    employerRoutingNumber: '',
    employerAccountType: '',
    eftConsent: false,
    minimumRequiredHoursWorked: '',
    premiumsAddedToEmployeesWages: '',
    premiumTaxation: '',
    rate: '',
    workLocation: '',
    paidFamilyLeavePremiumsAddedToEmployeesWages: '',
    paidFamilyLeavePremiumTaxation: '',
    paidMedicalLeavePremiumsAddedToEmployeesWages: '',
    paidMedicalLeavePremiumTaxation: '',
    paidFamilyLeaveRate: '',
    paidMedicalLeaveRate: ''
}